import { Route, Routes } from 'react-router-dom';
import { ErrorBoundary } from './components/ErrorBoundary';
import { ProtectedRoute } from './components/ProtectedRoute';
import { useAuth } from './contexts/AuthContext';
import { useRealtimeSync } from './hooks/useRealtimeSync';
import { HomePage } from './pages/HomePage';
import { TaxCalculatorPage } from './pages/TaxCalculatorPage';

function App() {
  const { session } = useAuth();

  useRealtimeSync(session?.user.id ?? null);

  return (
    <ErrorBoundary>
      <ProtectedRoute>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/tax-calculator" element={<TaxCalculatorPage />} />
        </Routes>
      </ProtectedRoute>
    </ErrorBoundary>
  );
}

export default App;
